// extracted by mini-css-extract-plugin
export default {"container":"AttachedImages_container__N2yuT","label":"AttachedImages_label__zGS6+","title":"AttachedImages_title__wKYPn","images":"AttachedImages_images__iEC53"};